// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_3t-0";
export var orangeButton = "_3t-1";